import { render } from "./VDialogAdapted.vue?vue&type=template&id=b41bbee0&ts=true"
import script from "./VDialogAdapted.vue?vue&type=script&lang=ts"
export * from "./VDialogAdapted.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__